import styles from "./footer.module.css"
import { ReactComponent as Logo } from "../../img/logo.svg"
import { Link, useLocation } from "react-router-dom"
import { links, supportMailtoUrl } from "../shared/constants/constants"

const Footer = () => {
	const { pathname } = useLocation()

	const handleGetStarted = () => {
		window.location.href = `${links.startupsSignUp}?plan=hiring`
	}

	const handleLogoLinkClick = (e) => {
		if (pathname === "/") {
			e.preventDefault()
			window.scrollTo({ top: 0, left: 0, behavior: "auto" })
			return
		}
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				window.scrollTo({ top: 0, left: 0, behavior: "auto" })
			})
		})
	}

	return (
		<footer className={styles.footer}>
			<div className={`container ${styles.footerInner}`}>
				<div className={styles.footerTop}>
					<div className={styles.footerBrand}>
						<Link
							to="/"
							className={styles.logoLink}
							aria-label="Techcore home"
							onClick={handleLogoLinkClick}
						>
							<span className={styles.logoWrap}>
								<Logo />
							</span>
						</Link>
						<p className={styles.tagline}>
							The agentic HR platform for growing teams. Source from a curated network of individual talents and agencies, then onboard, manage, and scale without switching tools.
						</p>
					</div>

					<div className={styles.footerCols}>
						<div className={styles.col}>
							<h3 className={styles.colTitle}>Product</h3>
							<a href="/#pillars" className={styles.footerLink}>
								Platform
							</a>
							<Link to="/pricing" className={styles.footerLink}>
								Pricing
							</Link>
							<a href={links.startupsSignUp} className={styles.footerLink}>
								Get started
							</a>
						</div>
						<div className={styles.col}>
							<h3 className={styles.colTitle}>Company</h3>
							<a href={supportMailtoUrl} className={styles.footerLink}>
								Contact
							</a>
							<button type="button" className={styles.footerLinkButton} onClick={handleGetStarted}>
								Sign up
							</button>
						</div>
						<div className={styles.col}>
							<h3 className={styles.colTitle}>Ecosystem</h3>
							<Link to="/talents" className={styles.footerLink}>
								For talents
							</Link>
							<Link to="/agencies" className={styles.footerLink}>
								For agencies
							</Link>
						</div>
						<div className={styles.col}>
							<h3 className={styles.colTitle}>Legal</h3>
							<button type="button" className={styles.footerLinkButton}>
								Privacy
							</button>
							<button type="button" className={styles.footerLinkButton}>
								Terms
							</button>
						</div>
					</div>
				</div>

				<div className={styles.footerBottom}>
					<span className={styles.copyright}>© {new Date().getFullYear()} Techcore. All rights reserved.</span>
					<a href={supportMailtoUrl} className={styles.email}>
						support@techcore.io
					</a>
				</div>
			</div>
		</footer>
	)
}

export default Footer
